export enum SprintPurpose {
  AWARENESS = 'awareness',
  DEVELOPMENT = 'development',
  CUSTOM = 'custom'
}
